import { PRODUCT_TYPES } from '@schuettflix/interfaces';
import primaryBulkGoodsLargeImg from '@/images/primary_bulk_goods_large.png';
import recyclingBulkGoodsLargeImg from '@/images/recycling_bulk_goods_large.jpg';
import asphaltLargeImg from '@/images/asphalt_large.jpg';
import concreteLargeImg from '@/images/concrete_large.png';
import hazardousWasteLargeImg from '@/images/hazardous_waste_large.jpg';
import nonHazardousWasteLargeImg from '@/images/non_hazardous_waste_large.jpg';

export const productTypeToImageMap = {
    // =================================
    // Handled by custom-request-service
    // =================================
    // Materials
    CUSTOM_BULK_MATERIAL: primaryBulkGoodsLargeImg,
    CUSTOM_RECYCLED_BULK_MATERIAL: recyclingBulkGoodsLargeImg,
    CUSTOM_CONCRETE: concreteLargeImg,
    CUSTOM_ASPHALT: asphaltLargeImg,
    // Waste
    CUSTOM_NON_HAZARDOUS_WASTE_DISPOSAL: nonHazardousWasteLargeImg,
    CUSTOM_NON_HAZARDOUS_WASTE_RECYCLING: nonHazardousWasteLargeImg,
    CUSTOM_HAZARDOUS_WASTE_DISPOSAL: hazardousWasteLargeImg,
    CUSTOM_HAZARDOUS_WASTE_RECYCLING: hazardousWasteLargeImg,
    // Transports
    CUSTOM_TRANSPORT: undefined,
    // Material Services
    CUSTOM_SERVICE: undefined,
    CUSTOM_SERVICE_ANALYSIS: undefined,
    CUSTOM_SERVICE_ACCOMPANYING_DOCUMENT: undefined,
    // Transport Services
    CUSTOM_SERVICE_TRANSPORT: undefined,
    CUSTOM_SERVICE_TOLL: undefined,
    CUSTOM_SERVICE_WAITING_TIME: undefined,
    // ===================================
    // Handled by material-channel-service
    // ===================================
    // Materials
    BULK_MATERIAL: primaryBulkGoodsLargeImg,
    RECYCLED_BULK_MATERIAL: recyclingBulkGoodsLargeImg,
    // Waste
    NON_HAZARDOUS_WASTE_DISPOSAL: nonHazardousWasteLargeImg,
    NON_HAZARDOUS_WASTE_RECYCLING: nonHazardousWasteLargeImg,
    HAZARDOUS_WASTE_DISPOSAL: hazardousWasteLargeImg,
    HAZARDOUS_WASTE_RECYCLING: hazardousWasteLargeImg,
    // ============================
    // Handled by transport-service
    // ============================
    TRANSPORT: undefined,
    // ============================
    // Not Handled by any channel
    // ============================
    SERVICE_TOLL: undefined,
    SERVICE_WEIGHING_NOTE: undefined,
    SERVICE_ACCOMPANYING_DOCUMENT: undefined,
    SERVICE_ENERGY_SURCHARGE: undefined,
} as const satisfies Record<PRODUCT_TYPES, string | undefined>;
